//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '@/utils/date.js'
import {
  deleteFamily,
  queryFamily,
} from '@/https/enroll'
import iconContract from '@/assets/img/icon_contract.png'
import iconJob from '@/assets/img/icon_job.png'
import searchEmptyImg from '@/assets/img/no_search.png'
import { confirm } from '@/utils/dialog'
import CEmpty from '@/components/CEmpty'
import familyInfoWriteItem from './familyInfoWriteItem'

export default {
  components: {
    familyInfoWriteItem,
    CEmpty,
  },

  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return {
      familyInfoWriteItem,
      iconContract,
      iconJob,
      searchEmptyImg,
      currComponent: '',
      currentFamily: {},
      listShow: true,
      familyList: [],
    }
  },

  computed: {
    familyConfig () {
      return this.options?.bmbMbDetailItem?.bmbTzzdList?.filter((el) => el.zdmc === '家庭成员')[0] || {}
    },
  },

  watch: {
    'options.ksxxItem': {
      handler (val) {
        if (val.wid) {
          this.setFamilyList()
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    formatDate,

    async addFamily () {
      this.currentFamily = { ksWid: this.options.ksxxItem.wid }

      await this.$nextTick()
      this.listShow = false
    },

    async editCurrentFamily (item) {
      this.listShow = false

      await this.$nextTick()
      this.currentFamily = {
        ...item,
        ksWid: this.options.ksxxItem.wid,
      }
    },

    async setFamilyList () {
      const { data } = await queryFamily({ wid: this.options.ksxxItem.wid })

      this.familyList = data || []
    },

    async deleteFamily (item) {
      confirm({
        title: '提示',
        message: '此操作将永久删除记录，是否继续？',
        beforeConfirm: async (done) => {
          const { code } = await deleteFamily({
            ksWid: this.options.ksxxItem.wid,
            wids: [item.wid],
          })

          if (+code === 0) {
            this.setFamilyList()
            done()
          }
        },
      })
    },
  },
}
